import actions from './actions';

import { handleActions } from 'redux-actions';
import uuid from 'uuid/v4';

const defaultState = {
  identity: uuid(),
};

export default handleActions(
  {
    [actions.setIdentity]: (state, { payload }) => ({
      ...state,
      identity: payload,
    }),
  },
  defaultState,
);



// WEBPACK FOOTER //
// ./src/reducer.js